//
import Model from '@/models/Model'

/**
 * 
 */
export default class HrHoliday extends Model {

    /**
     * 
     */
    filters () {
        return [
            {
                name: 'period_year',
                type: 'date-year',
            },
            {
                name: 'normal_holidays',
                type: 'switch',
            },
            {
                name: 'disabled_period',
                type: 'switch',
            },
            {
                name: 'hr_employee_id',
                props: {
                    items: [ 
                        { names: 'Juan Perez', id: 2 },
                        { names: 'Juan Perez', id: 3 },
                    ],
                    itemText: ({ names, last_name1, last_name2 }) => [ names, last_name1, last_name2 ].join( ' ' ),
                    itemValue: 'id',
                    label: 'Empleado',
                    multiple: true,
                },
                type: 'select',
            },
        ]
    }

    /**
     * 
     */
    headers () {
        return [
            /*{
                text    : '#',
                value   : 'id',
            },*/
            {
                text    : 'Empleado',
                value   : ({ hr_employee }) => [ hr_employee.names, hr_employee.last_name1, hr_employee.last_name2 ].join( ' ' ),
                width   : '25%',
            },
            {
                align   : 'center',
                text    : 'Periodo (año)',
                value   : 'period_year',
            },
            {
                align   : 'center',
                text    : 'Asignado (dias)',
                value   : 'assigned_days',
            },
            {
                align   : 'center',
                text    : 'Consumido (dias)',
                value   : 'consumed_days',
            },
            {
                align   : 'center',
                text    : 'Pendiente (dias)',
                value   : 'pending_days',
            },
        ]
    }
    
    /**
     * 
     */
    includes () {
        return [
            'hr_employee',
        ]
    }

    /**
     * 
     */
    resource () {
        return 'hr_holiday'
    }
    
    /**
     * 
     */
    resources () {
        return 'Vacaciones'
    }
}